// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieWarning__wrapper-t7cH","cookie":"CookieWarning__cookie-LPKT","component":"CookieWarning__component-ueAR","dismiss":"CookieWarning__dismiss-UVgy"};